import css from 'styled-jsx/css'

import { common, sizes } from '../../../theme'


export default css`

.title {
  max-width: ${sizes.body.tablet.maxWidth};
  margin: auto;
  position: relative;
}

.title :global(.parallax-title) {
  top: 0;
}

.routes {
  margin-top: 12rem;
}

.routes :global(.label) {
  ${common.h3}
  font-weight: 400;
  text-align: left;
}

.routes :global(.route) {
    margin-bottom: 2rem;
  }

.links-media {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.links-media :global(.floating-image) {
  max-width: 300px;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .routes {
    margin-top: 0;
  }

  .links-media {
    display: none;
  }

  .routes :global(.route) {
    margin-bottom: 2rem;
  }

  .routes :global(.label) {
    ${common.h4}
  }
}
`
